import React, { Component } from "react";

import {
	FacebookShareButton,
	FacebookIcon,
	GooglePlusShareButton,
	GooglePlusIcon,
	TwitterShareButton,
	TwitterIcon,
	TelegramShareButton,
	TelegramIcon,
	WhatsappShareButton,
	WhatsappIcon,
	EmailShareButton,
	EmailIcon
} from "react-share";

const size = 25;

class Share extends Component {
	render() {
		const shareUrl =
			"http://especiales.diariodecadiz.es/infografia/2018/cuaresma/index.html";
		const title =
			"Procesiones e itinerarios de Semana Santa en Diario de Cádiz";

		return (
			<div className="Demo__container">
				<div className="Demo__some-network">
					<FacebookShareButton
						url={shareUrl}
						quote={title}
						className="Demo__some-network__share-button"
					>
						<FacebookIcon size={size} round />
					</FacebookShareButton>
				</div>

				<div className="Demo__some-network">
					<TwitterShareButton
						url={shareUrl}
						title={title}
						className="Demo__some-network__share-button"
					>
						<TwitterIcon size={size} round />
					</TwitterShareButton>
				</div>

				<div className="Demo__some-network">
					<WhatsappShareButton
						url={shareUrl}
						title={title}
						separator=":: "
						className="Demo__some-network__share-button"
					>
						<WhatsappIcon size={size} round />
					</WhatsappShareButton>
				</div>

				<div className="Demo__some-network">
					<TelegramShareButton
						url={shareUrl}
						title={title}
						className="Demo__some-network__share-button"
					>
						<TelegramIcon size={size} round />
					</TelegramShareButton>
				</div>

				<div className="Demo__some-network">
					<GooglePlusShareButton
						url={shareUrl}
						className="Demo__some-network__share-button"
					>
						<GooglePlusIcon size={size} round />
					</GooglePlusShareButton>
				</div>

				<div className="Demo__some-network">
					<EmailShareButton
						url={shareUrl}
						subject={title}
						body="body"
						className="Demo__some-network__share-button"
					>
						<EmailIcon size={size} round />
					</EmailShareButton>
				</div>
			</div>
		);
	}
}

export default Share;



// WEBPACK FOOTER //
// ./src/components/Share.js